import { Injectable } from '@angular/core';
import { BrandingV2Service, PartnerServiceInterface, SubscriptionLevel, WhitelabelService } from '@galaxy/partner';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { partnerId } from '../../globals';
import { FeatureFlagService } from './feature-flag.service';

const SubscriptionLevelsWithSalesOrders: SubscriptionLevel[] = [
  SubscriptionLevel.SUBSCRIPTION_LEVEL_ENTERPRISE,
  SubscriptionLevel.SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS,
  SubscriptionLevel.SUBSCRIPTION_LEVEL_PROFESSIONAL,
  SubscriptionLevel.SUBSCRIPTION_LEVEL_PROFESSIONAL_PLUS,
  SubscriptionLevel.SUBSCRIPTION_LEVEL_BASIC,
  SubscriptionLevel.SUBSCRIPTION_LEVEL_BASIC_PLUS,
  SubscriptionLevel.SUBSCRIPTION_LEVEL_STARTER,
];

@Injectable({ providedIn: 'root' })
export class PartnerService implements PartnerServiceInterface {
  public readonly partnerBrandName$: Observable<string>;

  constructor(
    private whitelabelService: WhitelabelService,
    private brandingService: BrandingV2Service,
    private featureFlagService: FeatureFlagService,
  ) {
    this.partnerBrandName$ = this.brandingService.getBranding(partnerId).pipe(
      map((branding) => branding.name),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
  }

  getPartnerId(): Observable<string> {
    return of(partnerId);
  }

  partnerSubscriptionLevelHasSalesOrders(): Observable<boolean> {
    return this.getSubscriptionLevel().pipe(
      map(
        (partnerSubscriptionLevel) =>
          partnerSubscriptionLevel === undefined || // VNDR (others?) doesn't have an assigned subscription
          SubscriptionLevelsWithSalesOrders.some((level) => level === partnerSubscriptionLevel),
      ),
    );
  }

  getFeatureFlag(featureId: string): Observable<boolean> {
    return this.featureFlagService.checkFeatureFlag(partnerId, '', featureId);
  }

  private getSubscriptionLevel(): Observable<SubscriptionLevel> {
    return this.whitelabelService.getConfiguration(partnerId).pipe(map((config) => config.subscriptionLevel));
  }
}
